import type { ImageWithLabel } from '../../types';

import { styled } from 'styled-components';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';

import NoPhotoIcon from '../../../assets/icons/no-photo-icon.svg?react';
import { useSwiperRtl } from '../../hooks/useSwiperRtl';
import { Figure } from '../figure/Figure';

const ImageContainerSC = styled.div`
  width: 9rem;
  aspect-ratio: 4 / 5;
  border: 1px solid ${(props) => props.theme.colors.slateGray[50]};
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: ${(props) => props.theme.colors.white};
`;

const ImageSC = styled.img`
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: contain;
  display: block;
`;

const NoPhotoIconSC = styled(NoPhotoIcon)`
  stroke: ${(props) => props.theme.colors.oxfordBlue[50]};
  width: 2rem;
  height: auto;
`;

const EmptyImageSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.slateGray[10]};
  border-radius: 0.25rem;
  width: 100%;
  height: 100%;
`;

export type Props = {
  images: ImageWithLabel[];
};

export const Gallery = ({ images }: Props) => {
  const { handleOnSwiper, textDirection } = useSwiperRtl();

  return (
    <Swiper
      key={textDirection}
      freeMode
      modules={[FreeMode]}
      onSwiper={handleOnSwiper}
      slidesPerView="auto"
      spaceBetween={15}
    >
      {images.map(({ id, image, label }, index) => (
        <SwiperSlide key={label || index} style={{ width: '9rem' }}>
          <Figure label={label || ''} labelPosition="center">
            <ImageContainerSC>
              {image ? (
                <ImageSC alt={label} data-test-id={id} src={image} />
              ) : (
                <EmptyImageSC>
                  <NoPhotoIconSC />
                </EmptyImageSC>
              )}
            </ImageContainerSC>
          </Figure>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
